import { Header } from './Header';
import { Footer } from './Footer';
import './Layout.css';
import { useAuth } from '../../providers/AuthProvider';
import { useLocation } from 'react-router-dom';
import { feedbackUrl } from '../../pages/members/Shared/Constants/AppConstant';

function Layout(props: any) {
    const auth = useAuth();
    const location = useLocation();
    let isAuthenticated = auth?.isAuthenticated();
    let isGpDiaryAdmin = auth?.isGpDiaryAdmin();

    return (
        <div>
            <Header />
            <div className="header-spacer"></div>
            <main>
                <div className="homepage-hero-banner">{props.children}</div>
            </main>
            <div className="header-spacer"></div>
            {location.pathname !== feedbackUrl && isAuthenticated && !isGpDiaryAdmin && (
                <a href="/feedback" className="feedback-button">
                    <span className="feedback-text">Feedback</span>
                </a>
            )}
            <Footer />
        </div>
    );
}
export default Layout;